export const projectInfoTabs = {
  PROJECT_INFO_SALE_INFO: 'sale_info',
  PROJECT_INFO_TOKEN_INFO: 'token_info',
  PROJECT_INFO_ABOUT_THE_PROJECT: 'about_the_project',
  PROJECT_INFO_YOUR_ALLOCATIONS: 'your_allocations',
  PROJECT_INFO_YOUR_MEDIA_RELEASES: 'media_releases',
  PROJECT_INFO_YOUR_TRADING_ANALYTICS: 'trading_analytic',
};

export const quickFilterConstants = {
  ALL: 1,
  ACTIVE: 2,
  COMPLETED: 3,
};
